import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Shell visual compartido para los diálogos de la app: card con cabecera
 * gris, botón de cierre y slots para acciones de cabecera, cuerpo y pie.
 * Los consumidores aportan las clases de tamaño vía `rootClass` y las del
 * cuerpo vía `bodyClass` (el shell no fija tamaños para evitar conflictos).
 */
@Component({
  selector: 'app-dialog-shell',
  imports: [TranslatePipe],
  templateUrl: './dialog-shell.component.html',
  host: { tabindex: '-1' },
})
export class DialogShellComponent {
  /** Icono de la cabecera (clase Font Awesome sin el prefijo `fa`). */
  icon = input('fa-image');
  /** Título de la cabecera. */
  title = input('');
  /** Clases extra del contenedor raíz (tamaño y alturas máximas). */
  rootClass = input('');
  /** Clases extra del cuerpo (padding, fondo, alineación). */
  bodyClass = input('');
  /** Si se muestra el pie (slot `[footer]`). */
  showFooter = input(true);
  /** Evento al pulsar el botón de cierre. */
  closed = output<void>();
}
